import { MoreVert } from '@mui/icons-material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMiViewScreenCepActivities from './MiViewScreenCepActivities.hook';
import { sortIconStyle, filterListIconStyle, moreVertIconStyle, boxStyle, menuButtonStyle } from './MiViewScreenCepActivities.style';
import { ScreenCepActivitiesProps } from './MiViewScreenCepActivities.types';
import MiViewAccountSelector from 'components/MiViewPreview/MiViewAccountSelector/MiViewAccountSelector';
import MiViewCEPAccordion from 'components/MiViewPreview/MiViewCEPAccordion/MiViewCEPAccordion';
import MiViewMenu from 'components/MiViewPreview/MiViewMenu/MiViewMenu';
import MiViewPlanSelector from 'components/MiViewPreview/MiViewPlanSelector/MiViewPlanSelector';
import MiViewScreenContent from 'components/MiViewPreview/MiViewScreenContent/MiViewScreenContent';
import MiViewScreenHeader from 'components/MiViewPreview/MiViewScreenHeader/MiViewScreenHeader';
import MiViewScreenSelector from 'components/MiViewPreview/MiViewScreenSelector/MiViewScreenSelector';
import { CustomerEngagementPlanning } from 'generated/maya.types';
import MiViewPreloader from 'miview-ui/components/MiViewPreloader';

const MiViewScreenCepActivities: React.FC<ScreenCepActivitiesProps> = ({
  defaultScreen,
  setNewScreen,
  fullScreen,
  setFullScreen,
  AEDocuments,
  IVADocuments,
  generalLoading,
}) => {
  const { t } = useTranslation();

  const {
    targets,
    tactics,
    screenLoading,
    plans,
    defaultPlan,
    cep,
    selectedAccount,
    setSelectedAccount,
    screenCepTargetsConfig,
    openedAccordion,
    renderKey,
  } = useMiViewScreenCepActivities(fullScreen, setFullScreen);

  return (
    <>
      <MiViewScreenHeader>
        <MiViewScreenSelector
          minWidth={ 60 }
          defaultValue={ defaultScreen }
          setNewScreen={ setNewScreen }>
        </MiViewScreenSelector>
        <MiViewPlanSelector minWidth={ 60 } defaultPlan={ defaultPlan } plans={ plans }></MiViewPlanSelector>
        <MiViewAccountSelector
          minWidth={ 60 }
          accounts={ targets }
          selectedAccount={ selectedAccount }
          setSelectedAccount={ setSelectedAccount }>
        </MiViewAccountSelector>
        <SortIcon sx={ sortIconStyle }/>
        <FilterListIcon sx={ filterListIconStyle }/>

        <MiViewMenu menuList={ screenCepTargetsConfig.menuList } buttonStyle={ menuButtonStyle }>
          <MoreVert sx={ moreVertIconStyle }/>
        </MiViewMenu>
      </MiViewScreenHeader>
      <MiViewScreenContent>
        {
          !screenLoading && !generalLoading && !!tactics.length && (
            <MiViewCEPAccordion
              key={ renderKey }
              cep={ cep as CustomerEngagementPlanning }
              tactics={ tactics }
              opened={ openedAccordion }
              AEDocuments={ AEDocuments }
              IVADocuments={ IVADocuments }
            />

          )
        }
        {
          !screenLoading && !generalLoading && !tactics.length ? (
            <Box sx={ boxStyle }>
              { t('maya_cep_step_miview_preview_target_screen_no_data') }
            </Box>
          ) : null
        }
        {
          (screenLoading || generalLoading)
            && <MiViewPreloader size={ 50 }></MiViewPreloader>
        }
      </MiViewScreenContent>
    </>
  );
};

export default MiViewScreenCepActivities;
